import { create } from "zustand";
import { State } from "@/models";

export const useStore = create<State.App>()((set) => ({
  setAllState: (newState: State.App) => set(() => ({ ...newState })),
  setState: (key: keyof State.App, value: any) => set(() => ({ [key]: value })),
}));
